
export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-gray-50 to-gray-100 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <h3 className="text-2xl font-light tracking-wider text-gray-800 mb-4">
              POCKET
              <span className="block text-xs bg-gradient-to-r from-pink-400 via-blue-400 to-teal-400 bg-clip-text text-transparent font-normal">
                WONDERS
              </span>
            </h3>
            <p className="text-gray-600 font-light leading-relaxed mb-6">
              口袋奇观 - 发现好玩有趣的宝石与首饰，每一件都充满惊喜与乐趣。
            </p>
            <div className="flex space-x-4">
              <button className="w-10 h-10 bg-gradient-to-r from-pink-400 to-pink-500 text-white rounded-full flex items-center justify-center hover:from-pink-500 hover:to-pink-600 transition-all cursor-pointer">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-wechat-line"></i>
                </div>
              </button>
              <button className="w-10 h-10 bg-gradient-to-r from-blue-400 to-blue-500 text-white rounded-full flex items-center justify-center hover:from-blue-500 hover:to-blue-600 transition-all cursor-pointer">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-weibo-line"></i>
                </div>
              </button>
              <button className="w-10 h-10 bg-gradient-to-r from-teal-400 to-teal-500 text-white rounded-full flex items-center justify-center hover:from-teal-500 hover:to-teal-600 transition-all cursor-pointer">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-instagram-line"></i>
                </div>
              </button>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-light text-gray-800 mb-6 tracking-wide">快速导航</h4>
            <ul className="space-y-3">
              <li><a href="#" className="text-gray-600 hover:text-pink-500 font-light transition-colors cursor-pointer">首页</a></li>
              <li><a href="#" className="text-gray-600 hover:text-blue-500 font-light transition-colors cursor-pointer">好玩宝石</a></li>
              <li><a href="#" className="text-gray-600 hover:text-teal-500 font-light transition-colors cursor-pointer">有趣首饰</a></li>
              <li><a href="#" className="text-gray-600 hover:text-pink-500 font-light transition-colors cursor-pointer">奇观故事</a></li>
              <li><a href="#" className="text-gray-600 hover:text-blue-500 font-light transition-colors cursor-pointer">联系我们</a></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-light text-gray-800 mb-6 tracking-wide">服务项目</h4>
            <ul className="space-y-3">
              <li><a href="#" className="text-gray-600 hover:text-teal-500 font-light transition-colors cursor-pointer">宝石鉴赏</a></li>
              <li><a href="#" className="text-gray-600 hover:text-pink-500 font-light transition-colors cursor-pointer">趣味定制</a></li>
              <li><a href="#" className="text-gray-600 hover:text-blue-500 font-light transition-colors cursor-pointer">收藏指导</a></li>
              <li><a href="#" className="text-gray-600 hover:text-teal-500 font-light transition-colors cursor-pointer">奇观探索</a></li>
              <li><a href="#" className="text-gray-600 hover:text-pink-500 font-light transition-colors cursor-pointer">知识分享</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-light text-gray-800 mb-6 tracking-wide">联系方式</h4>
            <div className="space-y-4">
              <div className="flex items-center">
                <div className="w-5 h-5 flex items-center justify-center text-pink-500 mr-3">
                  <i className="ri-map-pin-line"></i>
                </div>
                <span className="text-gray-600 font-light">北京市朝阳区艺术区</span>
              </div>
              <div className="flex items-center">
                <div className="w-5 h-5 flex items-center justify-center text-blue-500 mr-3">
                  <i className="ri-phone-line"></i>
                </div>
                <span className="text-gray-600 font-light">400-888-9999</span>
              </div>
              <div className="flex items-center">
                <div className="w-5 h-5 flex items-center justify-center text-teal-500 mr-3">
                  <i className="ri-mail-line"></i>
                </div>
                <span className="text-gray-600 font-light">info@pocket-wonders.com</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-200 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-500 font-light text-sm">
            © 2024 Pocket Wonders. 保留所有权利。
          </p>
          <div className="flex items-center space-x-6 mt-4 md:mt-0">
            <a href="#" className="text-gray-500 hover:text-pink-500 font-light text-sm transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-gray-500 hover:text-blue-500 font-light text-sm transition-colors cursor-pointer">服务条款</a>
            <a href="https://readdy.ai/?origin=logo" className="text-gray-500 hover:text-teal-500 font-light text-sm transition-colors cursor-pointer">Powered by Readdy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
